import { gql } from '@apollo/client';

export default gql`
  mutation AssignSquadShiftsMatches($input: AssignSquadShiftMatchInput!) {
    assignSquadShiftsMatches(input: $input) {
      count
    }
  }
`;
